export default "__VITE_ASSET__DKbzghpC__";